import React from 'react';
import { Wind, RefreshCw } from 'lucide-react';

/**
 * Компонент секции вентиляции и воздухообмена
 */
const VentilationSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Wind className="w-5 h-5 mr-2 text-green-500" />
        Вентиляция и воздухообмен
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип вентиляции */}
        <div>
          <label htmlFor="ventilationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип вентиляции
          </label>
          <select
            id="ventilationType"
            name="ventilationType"
            value={formData.ventilationType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="natural">Естественная</option>
            <option value="mechanical">Механическая</option>
            <option value="mechanical_recovery">Механическая с рекуперацией</option>
          </select>
        </div>

        {/* Кратность инфильтрации */}
        <div>
          <label htmlFor="infiltrationRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Воздухопроницаемость здания
          </label>
          <select
            id="infiltrationRate"
            name="infiltrationRate"
            value={formData.infiltrationRate}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="low">Низкая (современное здание, хорошая герметизация)</option>
            <option value="medium">Средняя (стандартное качество)</option>
            <option value="high">Высокая (старое здание, много щелей)</option>
          </select>
        </div>
        
        {/* Рекуперация тепла */}
        <div className="col-span-full">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="hasHeatRecovery"
              name="hasHeatRecovery"
              checked={formData.hasHeatRecovery}
              onChange={handleInputChange}
              className="form-checkbox"
              disabled={formData.ventilationType !== 'mechanical_recovery'}
            />
            <label htmlFor="hasHeatRecovery" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Используется рекуперация тепла
            </label>
          </div>
          {formData.ventilationType !== 'mechanical_recovery' && formData.hasHeatRecovery && (
            <p className="text-xs text-orange-600 dark:text-orange-400 mt-1">
              Рекуперация доступна только для механической приточно-вытяжной вентиляции с рекуперацией
            </p>
          )}
        </div>

        {/* Эффективность рекуперации */}
        {formData.hasHeatRecovery && (
          <div className="col-span-full">
            <label htmlFor="recoveryEfficiency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <RefreshCw className="w-4 h-4 mr-1 text-green-500" />
              Эффективность рекуперации, %
            </label>
            <input
              type="text"
              id="recoveryEfficiency"
              name="recoveryEfficiency"
              value={formData.recoveryEfficiency}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.recoveryEfficiency ? 'input-error' : ''}`}
              placeholder="Например: 70"
            />
            {errors.recoveryEfficiency && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.recoveryEfficiency}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              Современные рекуператоры обеспечивают эффективность 60-85%
            </p>
          </div>
        )}
      </div>
      
      <div className="mt-4 p-3 bg-green-100 dark:bg-green-900/30 rounded-lg border border-green-200 dark:border-green-700">
        <div className="flex items-start">
          <Wind className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Важная информация о вентиляции
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              На вентиляцию и инфильтрацию может приходиться до 30-40% всех теплопотерь в здании.
              Система вентиляции с рекуперацией тепла позволяет сохранить до 85% тепловой энергии
              при обеспечении необходимого воздухообмена.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VentilationSection;